import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
} from "reactstrap";
import { useSelector } from "react-redux";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import "./COLlegadasPage.css";
import './SharedLoading.css';
import API_BASE_URL from "../config";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const VuelosPage = () => {
  const token = useSelector((state) => state.auth.token);
  const decoded = token ? jwtDecode(token) : null;
  const estacionUsuario = decoded?.estacion?.trim().toUpperCase();

  const [vuelos, setVuelos] = useState([]);
  const [pasajeros, setPasajeros] = useState([]);
  const [selectedVuelo, setSelectedVuelo] = useState(null);
  const [pasajeroSeleccionado, setPasajeroSeleccionado] = useState(null);
  const [modalAsignarVisible, setModalAsignarVisible] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [colaboradores, setColaboradores] = useState([]);
  const [busquedaSiglas, setBusquedaSiglas] = useState("");
  const [busquedaVuelo, setBusquedaVuelo] = useState("");
  const [loadingPage, setLoadingPage] = useState(true);


const fechaHoy = moment().format("dddd, D [de] MMMM [de] YYYY"); // Ejemplo: "miércoles, 26 de junio de 2025"

  

  useEffect(() => {
    if (token) {
      obtenerVuelosDelDia();
    }
  }, [token]);

  const obtenerVuelosDelDia = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}api/vuelos/hoy`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const vuelosDelDia = res.data.filter(
        (v) => v.tipoServicio === "LLEGADAS"
      );
      setVuelos(vuelosDelDia);
    } catch (error) {
      console.error("❌ Error al obtener vuelos:", error);
      toast.error("Error al obtener vuelos del día");
    } finally {
      setLoadingPage(false);
    }
  };

  const obtenerEtapasPorVuelo = (tipoVuelo) => {
  if (tipoVuelo === 'INTERNACIONAL') {
    return ['ASIGNADO', 'INICIADO', 'STDBY', 'MIGRACION', 'EQUIPAJE', 'ADUANA', 'CONCLUIDO'];
  } else {
    return ['ASIGNADO', 'INICIADO', 'STDBY', 'EQUIPAJE', 'CONCLUIDO'];
  }
};

const BarraProgresoStatus = ({ tipoVuelo, status }) => {
  const etapas = obtenerEtapasPorVuelo(tipoVuelo);
  const currentIndex = etapas.indexOf(status?.toUpperCase());

  return (
    <div className="status-progress-bar">
      {etapas.map((etapa, idx) => {
        const isActive = idx <= currentIndex;
        return (
          <React.Fragment key={etapa}>
            <div className={`circle-step ${isActive ? 'active' : ''}`} title={etapa}>
              <i className="fas fa-check"></i>
            </div>
            {idx < etapas.length - 1 && <div className={`step-line ${isActive ? 'active' : ''}`} />}
          </React.Fragment>
        );
      })}
    </div>
  );
};


  const obtenerColaboradores = async () => {
  try {
    const res = await axios.get(`${API_BASE_URL}api/bitacora/en-turno-detalles`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    // Primero filtramos por estación
    const colaboradoresFiltrados = res.data.filter(
      (colab) => colab.estacion?.trim().toUpperCase() === estacionUsuario
    );

    

    // Luego eliminamos duplicados por noColaborador
    const colaboradoresUnicos = colaboradoresFiltrados.filter(
      (colab, index, self) =>
        index === self.findIndex((c) => c.noColaborador === colab.noColaborador)
    );

    setColaboradores(colaboradoresUnicos);
  } catch (error) {
    console.error("❌ Error al obtener colaboradores:", error);
    toast.error("Error al cargar colaboradores disponibles");
  }
};




  const abrirModal = async (vuelo) => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}api/vuelos/pasajeros/${vuelo.flight_number}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    const totalPasajeros = res.data.length;
    setSelectedVuelo(vuelo);
    setPasajeros(res.data); // por si necesitas mostrar el total
    await obtenerColaboradores();
    setModalAsignarVisible(true);
    toast.info(`Selecciona ${totalPasajeros} operadores para este vuelo`);
  } catch (error) {
    console.error("❌ Error al obtener pasajeros:", error);
    toast.error("Error al cargar pasajeros del vuelo");
  }
};



  const asignarServicio = async (colab) => {
  try {
    const payload = {
      nombrePax: `${pasajeroSeleccionado.nombre} ${pasajeroSeleccionado.apellido}`,
      aerolinea: "AM", // puedes cambiarlo si es dinámico
      noVuelo: selectedVuelo.flight_number,
      noAsiento: pasajeroSeleccionado.tipo_pasajero,
      origenVuelo: selectedVuelo.latest_departure_airport,
      destinoVuelo: selectedVuelo.latest_arrival_airport,
      fechaInput: moment().format("YYYY-MM-DD"),
      horaInicio: moment().format("YYYY-MM-DD HH:mm:ss"),
      estacion: estacionUsuario,
      usuarioInicio: 999,
      noColaborador: colab.noColaborador,
      statusServicio: "ASIGNADO",
      tipoVuelo: selectedVuelo.tipoServicio,
      pnr: pasajeroSeleccionado.pnr,
      int_nac: selectedVuelo.tipoVuelo,
    };

    const res = await axios.post(`${API_BASE_URL}api/servicios/asignarLlegadas`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });

    toast.success("✅ Servicio asignado exitosamente");

    // Opcional: cerrar modales y limpiar
    setModalAsignarVisible(false);
    setModalVisible(false);
    setPasajeroSeleccionado(null);
    setSelectedVuelo(null);
    setPasajeros([]);

  } catch (error) {
    console.error("❌ Error al asignar servicio:", error);
    toast.error("Error al asignar el servicio");
  }
};

const asignarMultipleServicios = async (colaboradoresSeleccionados) => {
  try {
    const payloads = colaboradoresSeleccionados.map((colab) => ({
      aerolinea: "AM",
      noVuelo: selectedVuelo.flight_number,
      origenVuelo: selectedVuelo.latest_departure_airport,
      destinoVuelo: selectedVuelo.latest_arrival_airport,
      fechaInput: moment().format("YYYY-MM-DD"),
      horaInicio: moment().format("YYYY-MM-DD HH:mm:ss"),
      estacion: estacionUsuario,
      usuarioInicio: 999,
      noColaborador: colab.noColaborador,
      statusServicio: "ASIGNADO",
      tipoVuelo: selectedVuelo.tipoServicio,
      int_nac: selectedVuelo.tipoVuelo,
    }));

    // Puedes usar Promise.all para mandar todos en paralelo
    await Promise.all(
      payloads.map((payload) =>
        axios.post(`${API_BASE_URL}api/servicios/asignarLlegadas`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        })
      )
    );

    toast.success("✅ Servicios asignados correctamente");
    setModalAsignarVisible(false);
    setSelectedVuelo(null);
    setPasajeros([]);
  } catch (error) {
    console.error("❌ Error al asignar servicios múltiples:", error);
    toast.error("Error al asignar los servicios");
  }
};



  const cerrarModal = () => {
    setModalVisible(false);
    setPasajeros([]);
    setSelectedVuelo(null);
  };
  const colaboradoresFiltradosPorBusqueda = colaboradores.filter((colab) =>
  colab.siglas?.toUpperCase().includes(busquedaSiglas)
);

const vuelosOrdenados = [...vuelos].sort((a, b) => {
  const horaA = moment.utc(a.published_arrival_time).tz("America/Mexico_City");
  const horaB = moment.utc(b.published_arrival_time).tz("America/Mexico_City");
  return horaA - horaB;
});


const vuelosFiltrados = vuelosOrdenados.filter((vuelo) =>
  vuelo.flight_number.toUpperCase().includes(busquedaVuelo)
);



  if (loadingPage) {
    return (
      <div className="container mt-4">
        <div className="page-loading-overlay">
          <div className="page-loading-spinner" />
          <p className="page-loading-text">Cargando vuelos de llegadas...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <ToastContainer />
      <h2 className="mb-1 titulo-llegadas">🛬 Vuelos de Llegadas del Día</h2>
      <p className="fecha-llegadas mb-3">{fechaHoy}</p>

      <div className="mb-3">
  <input
    type="text"
    className="form-control"
    placeholder="Buscar por número de vuelo"
    value={busquedaVuelo}
    onChange={(e) => setBusquedaVuelo(e.target.value.toUpperCase())}
  />
</div>

     <div className="tabla-arribos-wrapper">
  <table className="tabla-arribos">
  <thead>
    <tr>
      <th colSpan="8" className="titulo-tabla-llegadas">LLEGADAS</th>
    </tr>
  <tr>
    <th>No.</th>
    <th>Hora de llegada</th>
    <th>Origen</th>
    <th>Vuelo</th>
    <th>Sala</th> {/* 👈 nueva columna */}
    <th>Cant. Servicios</th>
    <th>Tipo Vuelo</th>
    <th>Estatus</th>
  </tr>
</thead>


  <tbody>
  {vuelosFiltrados.map((vuelo, idx) => (
    <tr key={vuelo.id} onClick={() => abrirModal(vuelo)} className="fila-arribo">
      <td>{idx + 1}</td>
      <td>{moment(vuelo.published_arrival_time).add(1, 'hour').format("HH:mm")}</td>
      <td>{vuelo.latest_departure_airport}</td>
      <td>AM {vuelo.flight_number}</td>
      <td>{vuelo.sala || '—'}</td> {/* 👈 nueva celda */}
      <td>{vuelo.totalPasajeros}</td>
      <td>{vuelo.tipoVuelo}</td>
      <td className={vuelo.status === 1 ? 'estatus-completado' : 'estatus-pendiente'}>
        {vuelo.status === 1 ? (
          <>
            <i className="fas fa-check-circle icono-status"></i> Completado
          </>
        ) : (
          <>
            <i className="fas fa-clock icono-status"></i> Pendiente
          </>
        )}
      </td>
    </tr>
  ))}
  
</tbody>


  </table>
</div>


{modalVisible && (
  <div className="custom-modal-overlay" onClick={cerrarModal}>
    <div className="custom-modal" onClick={(e) => e.stopPropagation()}>
      {/* ... contenido del modal viejo de pasajeros, puedes eliminarlo si ya no lo usas ... */}
    </div>
  </div>
)}

{modalAsignarVisible && (
  <div className="custom-modal-overlay" onClick={() => setModalAsignarVisible(false)}>
    <div className="custom-modal" onClick={(e) => e.stopPropagation()}>
      <div className="custom-modal-header">
        <span className="title">
          Selecciona operadores para el vuelo: <strong>AM {selectedVuelo?.flight_number}</strong> &nbsp;
          ({pasajeros.length} pasajeros)
        </span>
        <button className="close-button" onClick={() => setModalAsignarVisible(false)}>✕</button>
      </div>
      <div className="custom-modal-body">
        <input
          type="text"
          placeholder="Buscar por siglas..."
          className="form-control mb-3"
          value={busquedaSiglas}
          onChange={(e) => setBusquedaSiglas(e.target.value.toUpperCase())}
        />

        <table className="table">
          <thead>
            <tr>
              <th>#</th>
              <th>Nombre</th>
              <th>Siglas</th>
              <th>Estación</th>
              <th>Seleccionar</th>
            </tr>
          </thead>
          <tbody>
            {colaboradoresFiltradosPorBusqueda.map((colab, idx) => (
              <tr key={colab.noColaborador}>
                <td>{idx + 1}</td>
                <td>{colab.nombreCompleto}</td>
                <td>{colab.siglas}</td>
                <td>{colab.estacion}</td>
                <td>
                  <input
                    type="checkbox"
                    checked={!!colab.seleccionado}
                    onChange={() =>
                      setColaboradores((prev) =>
                        prev.map((c) =>
                          c.noColaborador === colab.noColaborador
                            ? { ...c, seleccionado: !c.seleccionado }
                            : c
                        )
                      )
                    }
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="text-end">
          <button
            className="btn btn-primary"
            onClick={() => {
              const seleccionados = colaboradores.filter((c) => c.seleccionado);
              if (seleccionados.length !== pasajeros.length) {
                toast.warn(`Debes seleccionar exactamente ${pasajeros.length} operadores.`);
                return;
              }
              asignarMultipleServicios(seleccionados);
            }}
          >
            Asignar {pasajeros.length} operadores
          </button>
        </div>
      </div>
    </div>
  </div>
)}

    </div>
  );
};

export default VuelosPage;